const data = [
  {
    id: 1,
    name: "Full-Stack Developing",
    link: "developing",
    text: " You will learn the most up-to-date front-end and back-end tools by a project-based curriculum. You will make projects to fill your portfolios.",
    img: "https://clarusway.com/wp-content/uploads/2021/05/full-stack-developer.png",
  },
  {
    id: 2,
    name: "Data Science",
    link: "data-science",
    text: "You will learn how to extract knowledge and insights from different data types with our data science program. You’ll build data analysis and machine learning skills with real-world case studies, and hands-on exercises.",
    img: "https://clarusway.com/wp-content/uploads/2021/05/data-analytics.png",
  },
  {
    id: 3,
    name: "AWS-DEVOPS",
    link: "devops",
    text: "You will learn the fundamentals of cloud computing with using AWS in addition to learning Network basics, Linux, shell scripting, and Git.",
    img: "https://clarusway.com/wp-content/uploads/2021/05/AWS-Certification.png",
  },
];

export default data;
